
/**
 * 防止按钮在短时间内被多次点击，使用节流函数限制规定时间内只能点击一次。
 * <button v-throttle="debounce">节流提交</button>
 */
export default {
    mounted(el, binding) {
        if (typeof binding.value !== "function") {
            throw "callback must be a function";
        }

        let timer = null;
        el.handleData = ()=>{
            if(timer) clearTimeout(timer);
            if(!el.disabled) {
                el.disabled = true;
                binding.value();
                timer = setTimeout(() => {
                    el.disabled = false;
                }, 1000);
            }
        }

        el.addEventListener("click", el.handleData);
    },
    beforeUnmount(el){
        el.removeEventListener("click", el.handleData);
    }
};